import { absDependencies, addDependencies, BigNumberDependencies, bignumberDependencies, booleanDependencies, concatDependencies, cosDependencies, create, createUnitDependencies, divideDependencies, evaluateDependencies, formatDependencies, isNaNDependencies, isNegativeDependencies, isPositiveDependencies, logDependencies, maxDependencies, minDependencies, multiplyDependencies, numberDependencies, parseDependencies, powDependencies, roundDependencies, sinDependencies, stringDependencies, subtractDependencies, tanDependencies, toDependencies, typeOfDependencies, unitDependencies, UnitDependencies, } from "mathjs";
import { configureCustomUnits } from "./CustomUnits";
// floating point rounding errors were creating real world issues with large and small numbers
// so switching mathjs to use BigNumbers
// https://mathjs.org/docs/datatypes/bignumbers.html
export function createMathJsBigNumberInstance() {
    // There is a way to tree shake mathjs, but I couldn't figure out which dependencies it needed
    // https://mathjs.org/docs/custom_bundling.html
    return create({
        ...evaluateDependencies,
        ...parseDependencies,
        ...createUnitDependencies,
        ...typeOfDependencies,
        ...divideDependencies,
        ...multiplyDependencies,
        ...addDependencies,
        ...subtractDependencies,
        ...numberDependencies,
        ...bignumberDependencies,
        ...UnitDependencies,
        ...unitDependencies,
        ...BigNumberDependencies,
        ...tanDependencies,
        ...sinDependencies,
        ...cosDependencies,
        ...minDependencies,
        ...maxDependencies,
        ...logDependencies,
        ...roundDependencies,
        ...powDependencies,
        ...toDependencies,
        ...formatDependencies,
        ...absDependencies,
        ...booleanDependencies,
        ...stringDependencies,
        ...isNaNDependencies,
        ...isPositiveDependencies,
        ...isNegativeDependencies,
        ...concatDependencies,
    }, {
        // eslint-disable-next-line id-blacklist
        number: "BigNumber",
        precision: 64,
    });
}
function createMathJsBigNumberInstanceWithOnlyUnitConversion() {
    // There is a way to tree shake mathjs, but I couldn't figure out which dependencies it needed
    // https://mathjs.org/docs/custom_bundling.html
    return create({
        ...evaluateDependencies,
        ...parseDependencies,
        ...createUnitDependencies,
        ...typeOfDependencies,
        ...numberDependencies,
        ...bignumberDependencies,
        ...UnitDependencies,
        ...unitDependencies,
        ...BigNumberDependencies,
        ...toDependencies,
    }, {
        // eslint-disable-next-line id-blacklist
        number: "BigNumber",
        precision: 64,
    });
}
const electricalEvaluation = createMathJsBigNumberInstance();
configureCustomUnits(electricalEvaluation);
export const electricalEvaluationMathjs = electricalEvaluation;
const electricalOnlyUnitConversionEvaluation = createMathJsBigNumberInstanceWithOnlyUnitConversion();
configureCustomUnits(electricalOnlyUnitConversionEvaluation);
export const electricalOnlyUnitConversionEvaluationMathjs = electricalOnlyUnitConversionEvaluation;
export const mechanicalEvaluationMathjs = createMathJsBigNumberInstance();
export const mechanicalOnlyUnitConversionEvaluationMathjs = createMathJsBigNumberInstanceWithOnlyUnitConversion();
//# sourceMappingURL=Evaluators.js.map